import css from 'styled-jsx/css';

const styles = css`:root {
  /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */
  --black: #000000;
  --dark-gray: #b3b3b3;
  --error: red;
  --success: #248647;
  --green: green;
  --lightgreen: lightgreen;
  --gray-1: #787778;
  --gray-2: #bbbbbb;
  --gray-2-5: #d8d8d8;
  --gray-3: #eeeeee;
  --gray-4: #f8f8f8;
  --gray-5: #fafafa;
  --gray-6: #ebebeb;
  --gray-footer: #4f4f4f;
  --gray-footer-text: #757575;
  --gray-black: #111111;
  --heading-gray: #505050;
  --border-gray: #c8c8c8;
  --gray-background: rgba(0, 0, 0, 0.2);
  --warning: #daaa00;

  --mmr-yellow: #f8e71c;
  --mmr-red: #b41f00;
  --module-gray: #f7f7f7;
  --module-white: #ffffff;
  --primary-bg: #eeeeee;
  --clear: transparent;

  --risk-high: #e37a00;
  --risk-low: #7c993f;
  --risk-med: #ffcc00;
  --text-fg: #3b3b3b;
  --text-header: #4c5a6a;
  --tooltip-header: #4c5a69;
  --warm-grey: #898989;
  --white: #ffffff;
  --border-line: #b8b8b8;
  --orange-button: #e17a17;

  --text-dark: #3b3b3b;
  --text-med: #4f4f4f;
  --text-light: #898989;
  --text-xlight: #c4c4c4;
  --text-disabled: #b1b1b1;

  --subtle-blue-gray: #f7f9fa;
  --trp-dark-blue: #004b71;
  --trp-light-blue: #eef7fa;
  --trp-bright-blue: #05c3de;
  --ice-blue: #24c0d8;
  --row-blue: #06c3df;
  --trp-dark-blue: #0063ad;
  --dark-blue: #054c70;
  --dark-blue-2: #043954;
  --navy-blue: #0a4c71;
  --trp-nav-dark-blue: #061937;
  --trp-bottom-footer-blue: #0c2a4d;
  --trp-link-blue: #80c8ff;
  --trp-tag-blue: #00cfec;

  --navy-gradient: linear-gradient(115deg, #054c70, #086ea1);

  /* NASU Specifc Colors */
  /* TODO [2020-08-05]: change these colors to EDDS approved colors if they are not already */
  --BYOP-header-grey: #f0f3f5;
  --BYOP-header-contents-grey: #f7f9fa;

  /* 2020 colors */
  --primary-blue: #086ea1;
  --brand-interactive-blue: #006894;
  --grey-text: #475359;
  --gray-back: #f1f1f1;
  --gray-morningstar: #6b7880;
  --gray-non-rated-star: #b4babf;
  --gray-risk-reward-bar: #e9edf0;
  --green-risk-reward-thumb: #7d9845;
  --yellow-risk-reward-thumb: #ffcf3d;
  --orange-risk-reward-thumb: #e17a17;
  --gray-header-bottom-border: #879199;
  --gray-disabled-button: #e1e5e8;
  --border-white: #d3d7da;
  --link-blue: #006894;
  --qv-header-bottom-border: #d7dbde;
  --required-error-msg: #cc1f1f;
  --no-funds-error-msg: #dd3636;

  /* Beacon colors */
  --beacon-primary: #8b57d9;
  --input-field-title: #3b4b59;
  --background-blue: #253746;
}
:root {
  --page-max-width: 1230px;
  --page-padding: 32px;
  --module-gutter: 24px;
  --half-gutter: calc(var(--module-gutter) / 2);
  --quarter-gutter: calc(var(--half-gutter) / 2);
  --module-padding: 24px;
  --mobile-padding: 4px;
  --min-content: min-content;

  /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */
  --element-spacing-1: 8px;
  --element-spacing-2: calc(var(--element-spacing-1) * 2);
  --element-spacing-3: calc(var(--element-spacing-1) * 3);
  --element-spacing-4: calc(var(--element-spacing-1) * 4);
  --element-spacing-5: calc(var(--element-spacing-1) * 5);
  --element-spacing-6: calc(var(--element-spacing-1) * 6);
  --element-spacing-7: calc(var(--element-spacing-1) * 7);
  --element-spacing-8: calc(var(--element-spacing-1) * 8);
  --element-spacing-9: calc(var(--element-spacing-1) * 9);
  --element-spacing-10: calc(var(--element-spacing-1) * 10);
  --element-spacing-11: calc(var(--element-spacing-1) * 11);

  --border-thin-width: 1px;
  --border-width: 2px;
  --border-radius: 5px;

  /* New II Design Pattern - Introduced 11-12-2019 */
  --page-focus-width: 544px;
  --help-focus-width: 328px;
}
:root {
  --xxxsmall-font: 10px;
  --xxsmall-font: 12px;
  --xsmall-font: 14px;
  --small-font: 16px;
  --med-font: 18px;
  --large-font: 20px;
  --xlarge-font: 24px;
  --xxlarge-font: 36px;
  --xxxlarge-font: 48px;
  --title-font: 18px;
  --label-sup-font: 100%;

  --h1-font: 32px;
  --h2-font: 20px;
  --p1: 16px;
  --p2: 14px;
  --caption-size: 12px;

  --h1-font-mobile: 24px;
  --h2-font-mobile: 18px;
  --p1-mobile: 16px;
  --p2-mobile: 14px;
  --caption-size-mobile: 12px;

  --roboto-flex-font: 'Roboto Flex', sans-serif;
  --sans-novus: 'Roboto Flex Novus';
  --condensed-font: 'Roboto Flex Condensed', 'Roboto Flex', sans-serif;
  --condensed-bold: 'Roboto Flex Condensed Bold', 'Roboto Flex Condensed',
    sans-serif;
  --serif-font: 'IBM Plex Serif', serif;
  --mono-font: 'Roboto Flex', sans-serif;

  --roboto-reg: 'Roboto Flex Reg', sans-serif;
  --roboto-italic: 'Roboto Flex Italic', sans-serif;
  --roboto-bold: 'Roboto Flex Bold', sans-serif;
  --roboto-light: 'Roboto Flex', sans-serif;
  --roboto-black: 'Roboto Flex Black', sans-serif;

  --rocky-reg: 'Rocky Reg', sans-serif;
  --rocky-light: 'Rocky Light', sans-serif;

  --regular-weight: 400;
  --bold-weight: 700;
  --light-weight: 100;
  --normal-weight: normal;

  --checkbox-height: 25px;
  --checkbox-width: 25px;
}
:root {
  --button-width: 160px;
  --button-height: max-content;
  --active-repositioning: 1px;
  --button-line-height: 24px;
  --fix-content: fix-content;
  --additional-button-spacing: 12px;
  --buy-button-padding: 8px 12px;
  --buy-button-added-padding: 10px 12px;
  --close-x-width: 5%;
  --close-x-mobile-width: 10%;
  --docs-disclosure-btn-width: 45%;
  --beacon-button-margin: 0 auto var(--element-spacing-2);
}
.continue-button {
  font-family: 'Roboto Flex Reg', sans-serif;
  font-size: 16px;
  color: #ffffff;
  height: max-content;
  background-color: #086ea1;
  border: 1px solid #086ea1;
  border-radius: 5px;
  padding: 8px calc(8px * 2)
    8px calc(8px * 2);
  margin-bottom: calc(8px * 2);
  cursor: pointer;
}
.card-button {
  font-family: 'Roboto Flex Reg', sans-serif;
  font-size: 16px;
  color: #ffffff;
  height: max-content;
  background-color: #086ea1;
  border: 1px solid #086ea1;
  border-radius: 5px;
  padding: 8px calc(8px * 2)
    8px calc(8px * 2);
  margin-bottom: calc(8px * 2);
  cursor: pointer;
}
.continue-button.auto-width {
  width: auto;
}
.continue-button.margin-bottom-64 {
  margin-bottom: calc(8px * 8);
}
.continue-button {
  width: 160px;
}
.back-button {
  font-family: 'Roboto Flex Reg', sans-serif;
  font-size: 16px;
  color: #086ea1;
  background-color: #ffffff;
  border: 1px solid #086ea1;
  border-radius: 5px;
  padding: 8px calc(8px * 2)
    8px calc(8px * 2);
  width: 160px;
  height: max-content;
  text-align: center;
  cursor: pointer;
  margin-bottom: calc(8px * 2);
}
.secondary-button {
  font-family: 'Roboto Flex Reg', sans-serif;
  font-size: 16px;
  color: #086ea1;
  background-color: #ffffff;
  border: 1px solid #086ea1;
  border-radius: 5px;
  padding: 8px calc(8px * 2)
    8px calc(8px * 2);
  width: 160px;
  height: max-content;
  text-align: center;
  cursor: pointer;
  margin-bottom: calc(8px * 2);
}
.back-button.auto-width {
  width: auto;
}
.secondary-button.docs-disc {
  width: 45%;
  padding: 12px;
  font-weight: 700;
}
.secondary-button.docs-disc.opened {
  color: #248647;
  border-color: #248647;
}
.secondary-button.confirmation-section {
  width: auto;
  margin-right: calc(8px * 3);
  margin-top: 8px;
}
.card-button {
  width: 100%;
}
.link-button {
  font-family: 'Roboto Flex', sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: #086ea1;
  background-color: transparent;
  font-weight: bold;
  border: none;
  padding: 0;
  width: fix-content;
  text-align: center;
  cursor: pointer;
  outline: thin #ffffff;
}
.link-button.learn-more {
  font-size: 14px;
  color: #898989;
  margin-top: calc(8px * 3);
  margin-bottom: calc(8px * 3);
}
.link-button.select-funds-methodology {
  display: block;
  margin-left: auto;
}
.link-button.mail-a-check {
  font-weight: 100;
}
@media (max-width: 720px) {
  .link-button.select-funds-methodology {
    display: inline;
  }
}
.byop-add-fund {
  font-size: 16px;
  font-weight: 700;
  color: #086ea1;
  background-color: transparent;
  border: 1px solid #086ea1;
  border-radius: 5px;
  margin-left: 12px;
  padding: 8px 12px;
  text-align: center;
  display: flex;
  cursor: pointer;
}
.byop-disabled {
  font-size: 16px;
  font-weight: 700;
  color: #b4babf;
  background: #e1e5e8;
  border: 1px solid #e1e5e8;
  border-radius: 5px;
  margin-left: 12px;
  padding: 8px 12px;
  text-align: center;
  display: flex;
  cursor: not-allowed;
}
.byop-added-fund {
  font-size: 16px;
  font-weight: 700;
  color: green;
  background-color: transparent;
  border: none;
  padding: 10px 12px;
  text-align: center;
  display: flex;
  cursor: pointer;
}
.white-text {
  color: #ffffff;
}
.rdf-cart-button {
  font-family: 'Roboto Flex', sans-serif;
  font-size: 16px;
  font-weight: bold;
  color: #086ea1;
  cursor: pointer;
  background-color: #ffffff;
  border: none;
  border-radius: 5px;
  padding: 8px calc(8px * 2)
    8px calc(8px * 2);
  width: 160px;
  height: max-content;
  text-align: center;
  margin-bottom: calc(8px * 2);
}
.mm-cart-button {
  font-family: 'Roboto Flex', sans-serif;
  font-size: 16px;
  font-weight: bold;
  color: #086ea1;
  cursor: pointer;
  background-color: #ffffff;
  border: none;
  border-radius: 5px;
  padding: 8px calc(8px * 2)
    8px calc(8px * 2);
  width: 160px;
  height: max-content;
  text-align: center;
  margin-bottom: calc(8px * 2);
}
.back-button :hover {
  background-color: #eef7fa;
}
@media (prefers-reduced-motion: reduce) {
  .back-button,
  .secondary-button {
    transition: border 0.3s ease;
  }
}
.back-button:active {
  outline: none;
  position: relative;
  top: 1px;
}
.link-button:active {
  outline: none;
  position: relative;
  top: 1px;
}
.modal-continue-button {
  color: #ffffff;
  width: 160px;
  height: auto;
  background-color: #086ea1;
  border: 1px solid #086ea1;
  border-radius: 5px;
  padding: 8px;
  margin-left: calc(8px * 2);
  cursor: pointer;
}
.modal-continue-button :hover {
  background-color: #086ea1;
}
@media (max-width: 720px) {
  .modal-continue-button {
    margin-left: 0;
  }
}
.modal-close-button {
  color: #086ea1;
  background-color: #ffffff;
  border: 1px solid #086ea1;
  border-radius: 5px;
  padding: 8px calc(8px * 2)
    8px calc(8px * 2);
  width: 160px;
  height: max-content;
  cursor: pointer;
}
.modal-close-button :hover {
  background-color: #eef7fa;
}
.modal-close-button :active {
  outline: none;
}
.modal-close-x {
  border: none;
  background-color: #ffffff;
  cursor: pointer;
  margin-left: auto;
  width: 5%;
  padding: 0;
}
@media (max-width: 720px) {
  .modal-close-x {
    width: 10%;
    float: right;
  }
}
button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.filter-button {
  display: inline-block;
  margin: calc(8px * 2) 8px;
}
.beacon-icon-button {
  display: flex;
  justify-content: flex-end;
}
`;

export default styles;